import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import HGForm from 'components/HGForm';

const ForgotPassword = ({ triggerResetPassword }) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const handleForgotPassword = async (creds) => {
        try {
            const codeSent = await Auth.forgotPassword(creds.email);
            if (codeSent) {
                triggerResetPassword({
                    maskedEmail: codeSent.CodeDeliveryDetails.Destination,
                    username: creds.email,
                });
            }
        } catch (error) {
            const errorMsg =
                error.code === 'UserNotFoundException'
                    ? 'Email not found.  Please enter a valid email address and try again.'
                    : error.message;
            setErrorMessage(errorMsg);
            console.log('Code Verification Error: ', error);
        }
    };
    return (
        <>
            <h5 className="mb-3 text-center text-base font-medium text-foreground">
                Forgot Password
            </h5>
            <p className="mb-5 text-sm font-light text-foreground">
                Enter your email below and we will send you a code to reset your
                password. If you do not receive an email, please check your spam
                folder.
            </p>
            <HGForm
                fields={{
                    email: 'Email',
                }}
                handleSubmit={handleForgotPassword}
                buttonText="Send Code"
                errorMessage={errorMessage}
            />
        </>
    );
};

export default ForgotPassword;
